import cx from 'classnames'
import styles from './TotalAllocatedStatus.module.css'
import { formatMoney } from '@/utils/money-util'

export interface TotalAllocatedStatusProps {
  allocatedTotal: number
  payoutTotal: number
}

export function TotalAllocatedStatus({
  allocatedTotal,
  payoutTotal,
}: TotalAllocatedStatusProps) {
  return (
    <div
      className={cx(
        styles.totalAllocatedStatus,
        allocatedTotal === payoutTotal && styles.exact,
        allocatedTotal > payoutTotal && styles.over,
      )}
    >
      <span className={styles.allocatedAmount}>
        Total allocated: {formatMoney(allocatedTotal)}
      </span>{' '}
      of {formatMoney(payoutTotal)}
    </div>
  )
}
